import { GrtAiMarkdown } from '@/components/Markdown/GrtAiMarkdown';
import s from './style.module.scss';
const AskReason = (props) => {
    const { personalized_recommend_ask_reason = '' } = props;

    return (
        <>
            <div className={s['recommend-reasoning-wrap']}>
                <GrtAiMarkdown className="ai-markdown-box" content={personalized_recommend_ask_reason}></GrtAiMarkdown>
            </div>
        </>
    );
};
export default AskReason;
